import MaterialReactTable from 'material-react-table';
import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Button, CardTitle, Row } from "reactstrap";

const Datatable = ({columns, data = [], title, handleEdit, handleRemove, isEdit, handleAddButton, loading = false, Other = null, btnloading = false, userModules, enableRowAction = false}) => {
    const [btnid, setBtnid] = useState();

    return (
        <Row className="fade-in-content">
            <MaterialReactTable
                columns={columns || []}
                data={data || []}
                initialState={{
                    enableFullScreenToggle: false,
                    columnVisibility: { 'id': false }
                }}
                enableColumnResizing
                enableDensityToggle={false}
                enableHiding={false}
                state={{
                    expanded: true,
                    isLoading: Boolean(loading),
                    showProgressBars: Boolean(loading),
                }}
                renderTopToolbarCustomActions={() => {
                    return (
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 w-100 py-1">
                            <CardTitle className="h2 mb-0">{title}</CardTitle>
                            {
                                userModules?.add && <Button
                                        color="primary"
                                        size="sm"
                                        className="d-inline-flex align-items-center"
                                        onClick={handleAddButton}
                                    > <i className="fas fa-plus me-1" /> Add </Button>
                            }
                        </div>
                    );
                }}
                enableRowNumbers
                positionActionsColumn="last"
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        size: 160
                    }
                }}
                enableRowActions={enableRowAction}
                renderRowActions={({row}) =>(
                    <div className="action-buttons d-inline-flex align-items-center gap-1 flex-wrap">
                        {
                            !userModules?.isBlocking && userModules?.cub && 
                            <>
                                <Link
                                to="#"
                                className={`btn ${row.original.status == 2 ? "btn-danger" : "btn-success"} btn-sm`}
                                onClick={() => Other?.handleStatus(row.original.id, row.original.status == 2 ? 0 : 2)} 
                                title={row.original.status == 2 ? "Un-Block" : "Block"} >
                                    <i className={`fas ${Other?.isBlocking === row.original.id ? 'fa-spinner fa-spin' : `${row.original.status == 2 ? "fa-lock" : "fa-unlock"}`}`} />
                                </Link>{" "}
                            </>
                        }
                        {
                            userModules?.isBlocking && userModules?.cub && 
                            <>
                                <Link
                                to="#"
                                className={`btn ${row.status == 2 ? "btn-danger" : "btn-success"} btn-sm`}
                                onClick={() => Other?.handleStatus(row.original.id, row.original.status == 2 ? 0 : 2)}
                                title="Un-block" >
                                    <i className={`fas ${Other.isBlocking === row.original.id ? 'fa-spinner fa-spin' : `${row.status == 2 ? "fa-lock" : "fa-unlock"}`}`} />
                                </Link>{" "}
                            </>
                        }
                        {
                            userModules?.pd &&
                            <>
                                <Link
                                to="#"
                                className="btn btn-primary btn-sm"
                                onClick={() => Other?.handleEditProduct(row.original.code)} 
                                title="Products" >
                                    <i className={`fas ${Other?.isProduct === row.original.id ? 'fa-spinner fa-spin' : 'fa-table'}`} />
                                </Link>{" "}   
                            </>
                        }
                        {
                            userModules?.edit && 
                            <Link
                                to="#"
                                className="btn btn-outline-secondary btn-sm edit"
                                onClick={() => handleEdit(row.original.id)}
                                title="Edit" >
                                <i className={`fas ${isEdit == row.original.id ? 'fa-spinner fa-spin' : 'fa-pencil-alt'}`} />
                            </Link>
                        }
                        {
                            userModules?.delete && 
                            <>
                                {" "} <Link
                                    to="#"
                                    className={`btn btn-${row.original.status == 0 ? "danger" : "success"} btn-sm edit`}
                                    onClick={() => handleRemove(row.original.id, row.original.status == 1 ? 0 : 1, row.original.code)}
                                    title={row.original.status == 0 ? 'delete' : 'restore'} >
                                    <i className={`fas fas fa-trash-alt`} />
                                </Link>
                            </>
                        }

                        {
                            userModules?.callback && 
                            <>
                                {" "} <Link
                                    to="#"
                                    className={`btn btn-success btn-sm`}
                                    onClick={() => userModules?.callback(row.original)}
                                    title={`view ${ userModules?.istype == 'orderform' ? 'Orderform': 'Challan'}`} >
                                    <i className={`fas fa-file-pdf`} />
                                </Link>
                            </>
                        }

                        {
                            userModules?.pdf &&
                            <>
                                <Link
                                    to="#"
                                    className={`btn btn-outline-primary btn-sm`}
                                    title={"Print Invoice"}
                                    onClick={() =>{
                                        Other?.callback(row.original)
                                        setBtnid(row.original.id)
                                    }} >
                                    <i className={`${(row.original.id == btnid && btnloading) ? 'fa fa-spinner fa-spin':'fas fa-file-pdf'}`} />
                                </Link>

                                {
                                    Other?.isInvoice && (
                                        <>
                                            {" "}
                                            <Link
                                                to="#"
                                                title={"Send Invoice to Client"}
                                                className={`btn btn-outline-success ${row.original.status == 1 ? " disabled": ''} btn-sm`}
                                                onClick={() =>{
                                                    Other?.sendMsg(row.original)
                                                    setBtnid(row.original.id)
                                                }} >
                                                <i className={`fab fa-whatsapp fa-1x`} />
                                            </Link>
                                        </>
                                )}
                                {
                                    (Other?.isInvoice && row?.original?.is_lock == 0) ? (
                                        <>
                                            {" "}
                                            <Link
                                                to="#"
                                                title={"Convert to invoice"}
                                                className={`btn btn-outline-danger ${row.original.status == 1 ? " disabled": ''} btn-sm`}
                                                onClick={() =>{
                                                    Other?.convertInvoice(row.original)
                                                    setBtnid(row.original.id)
                                                }} >
                                                <i className={`${(row.original.id == btnid && btnloading) ? 'fa fa-spinner fa-spin':'fas fa-arrow-right'}`} />
                                            </Link>
                                        </>
                                    ): (
                                        row?.original?.is_lock && Other?.isProforma == 'Proforma' &&
                                        <>
                                            {" "}
                                            <Link
                                                target="_blank"
                                                to={`/invoice/print?invoice_number=${row.original.final_invoice}`}
                                                title={"View invoice"}
                                                className={`btn btn-outline-success btn-sm`} >
                                                <i className={`fas fa-eye`} />
                                            </Link>
                                        </>
                                    )
                            }
                            </>
                        }
                    </div>
                )}
            />
        </Row>
    )
}

export default Datatable